import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SearchSchema } from './-zod-schemas';
export const Route = createFileRoute('/_staff/payroll-core/_layout/operation-events/$eventId/compare/')({
  validateSearch: zodValidator(SearchSchema)
});